document.addEventListener("keyup", (event) => {
    if (event.target.closest(".userfilterinput")) {
        filter_user();
    }
});

document.addEventListener("click", (event) => {
    if (event.target.closest(".userelement")) {
        const userelement = event.target.closest(".userelement"),
            userelemente = document.querySelectorAll(".userelement");

        userelemente.forEach((element) => {
            element.classList.remove("bg-spotlight", "text-white");
            const svgs = element.querySelectorAll("svg");
            if (svgs) {
                svgs.forEach((svg) => {
                    svg.classList.remove("!fill-white");
                });
            }
        });

        userelement.classList.add("bg-spotlight", "text-white");
        const svgs = userelement.querySelectorAll("svg");
        if (svgs) {
            svgs.forEach((svg) => {
                svg.classList.add("!fill-white");
            });
        }
    }
});

const filter_user = () => {
    const user = document.querySelectorAll(".userelement");
    let filtereingabe = document.querySelector(".userfilterinput").value;

    filtereingabe = filtereingabe.toLowerCase();

    user.forEach((u) => {
        let name = u.dataset.name;
        name = name.toLowerCase();

        u.classList.add("hidden");
        u.classList.remove("bg-spotlight", "text-white");
        const svg = u.querySelector("svg");
        if (svg) svg.classList.remove("!fill-white");

        if (!name.includes(filtereingabe)) return;

        u.classList.remove("hidden");
    });

    // Gefilteter User in der Preview
    const ersterFilterUser = document.querySelector(".userelement:not(.hidden)");

    if (ersterFilterUser) {
        if (!ersterFilterUser.classList.contains("bg-spotlight")) ersterFilterUser.click();
    } else {
        document.querySelector(".user_show").innerHTML = "";
    }
};
